import { authClient } from '@/lib/api/ts-rest';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useAuth } from './useAuth';

export const useRequestPasswordResetForCurrentUser = () => {
  const { logout } = useAuth();

  const mutation = useMutation({
    mutationFn: async () => {
      const res = await authClient.requestMyPasswordReset();
      if (res.status !== 204) throw new Error('Request failed');
    },
    onSuccess: () => {
      toast.success(
        'Un lien de réinitialisation a été envoyé à votre adresse email. Vous allez être déconnecté pour des raisons de sécurité.'
      );
      // Déconnecter l'utilisateur après un court délai pour qu'il puisse voir le message
      setTimeout(() => {
        logout();
      }, 2000);
    },
    onError: (error: Error) => {
      toast.error(error.message || "Échec de l'envoi. Veuillez réessayer.");
    },
  });

  return {
    requestPasswordReset: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};

